import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import { Editor, bold, italic, underline, strikethrough, superscript, subscript } from 'react-draft-wysiwyg';
import { EditorState, ContentState } from 'draft-js';
import { convertToRaw } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';

/**
 * we changed the default state of this to fit our needs as things stand and removed a bunch of 
 * stuff from it. If you need to see what is available just remove the toolbar property and it will
 * go back to normal, go here for more deets: https://jpuri.github.io/react-draft-wysiwyg/#/docs?_k=jjqinp
 */

const defaultEditorOptions = {
  options: ['inline', 'list', 'textAlign', 'remove', 'history'],
  inline: {
    inDropdown: false,
    className: undefined,
    component: undefined,
    dropdownClassName: undefined,
    options: ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript'],
    bold: { icon: bold, className: undefined },
    italic: { icon: italic, className: undefined },
    underline: { icon: underline, className: undefined },
    strikethrough: { icon: strikethrough, className: undefined },
    superscript: { icon: superscript, className: undefined },
    subscript: { icon: subscript, className: undefined },
  }
}

class RichTextEditor extends Component {
  state = {
    editorState: EditorState.createEmpty()
  }

  componentDidMount() {
    const { htmlString } = this.props;
    if (htmlString) this.fromHtmlToEditor();
  }

  fromEditorToHtml = () => {
    const editorState = this.state.editorState.getCurrentContent()
    const rawContentState = convertToRaw(editorState);
    return draftToHtml(rawContentState);
  }

  fromHtmlToEditor = () => {
    const { htmlString } = this.props;
    const { contentBlocks, entityMap } = htmlToDraft(htmlString);
    const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
    const editorState = EditorState.createWithContent(contentState);
    this.setState({ editorState });
  }

  countNumberOfColumns = (str) => str.split(/\r\n|\r|\n/).length;

  handleBeforeInput = (value) => {
    if (this.checkMaxColumns(value)) return 'handled';
    if (this.checkMaxLength(value)) return 'handled';
  }

  handleReturn = () => {
    if(this.checkMaxColumns('')) return 'handled';
  }

  checkMaxColumns = (incomingText) => {
    const { maxColumns } = this.props;
    if (!maxColumns) return;

    const completeText = this.state.editorState.getCurrentContent().getPlainText() + incomingText;

    // this will only count if they start a new line. Word wrapping is a bit different =/ 
    const currentColumnCount = this.countNumberOfColumns(completeText);
    return currentColumnCount > maxColumns;
  }

  checkMaxLength = (incomingText) => {
    const { maxLength } = this.props;
    if (!maxLength) return;

    const completeText = this.state.editorState.getCurrentContent().getPlainText() + incomingText;
    return completeText.length > maxLength;
  }

  onEditorStateChange = (editorState) => {
    const { handleUpdate } = this.props;
    const htmlString = this.fromEditorToHtml();
    handleUpdate(htmlString);
    this.setState({ editorState });
  }

  render() {
    const { editorState } = this.state;

    return (
      <Editor
        editorState={editorState}
        toolbarClassName="toolbarClassName"
        wrapperClassName="wrapperClassName"
        editorClassName={(this.props.editorClassName) ? this.props.editorClassName : ''}
        onEditorStateChange={this.onEditorStateChange}
        handleBeforeInput={this.handleBeforeInput}
        handlePastedText={this.handleBeforeInput}
        handleReturn={this.handleReturn}
        toolbar={defaultEditorOptions}
      />
    );
  }
}

export default withStyles()(RichTextEditor);
